/**
 * Os parâmetros que a Cronometragem lê da barra de endereços.
 *
 * Moram FORA da tela porque quem os escreve está em outra: o Diagnóstico e a ficha do
 * produto montam o link que já abre a medição com o produto escolhido. Importar isso do
 * componente da tela criaria um ciclo assim que a tela passou a ser uma aba de Tempos.
 */

/**
 * O produto QUE ESTÁ SENDO MEDIDO viaja na barra de endereços: o link da Curadoria e o
 * da ficha já o carregam, e o piloteiro não precisa procurá-lo no seletor de novo.
 *
 * Não é `produto`, que é a chave da FICHA do produto ([[fichaDoProduto]]): desde que as
 * três telas do tempo viraram abas de uma rota só, as duas dividiriam o mesmo endereço, e
 * abrir uma ficha na Curadoria trocaria, calada, o produto da medição em Cronometrar.
 */
export const CRONOMETRAGEM_PRODUTO_PARAM = 'cronometrarProduto';

/** Como a rota antiga `/cronometragem?produto=X` escrevia o produto medido. */
export const CRONOMETRAGEM_PRODUTO_PARAM_LEGADO = 'produto';
